export default __webpack_public_path__ + "content/media/34.b24c49c1.jpg";